import { useTranslation } from "react-i18next";
import { AutocompleteType } from "../../../types/autoComplete";
import { AutocompleteBaseSingle } from "../fields/autocompleteBase/AutocompleteBaseSingle";

type SelectAutocompleteProps = {
  value: AutocompleteType | null;
  options: AutocompleteType[];
  onChange: (value: AutocompleteType | null) => void;
  translationNamespaces?: string[];
  placeholder?: string;
  disableClearable?: boolean;
};

export const SelectAutocompleteSingle = ({
  value,
  options,
  onChange,
  translationNamespaces = [],
  placeholder,
  disableClearable,
}: SelectAutocompleteProps) => {
  const { t } = useTranslation([...translationNamespaces, "common"]);

  return (
    <AutocompleteBaseSingle<AutocompleteType>
      value={value}
      getOptionLabel={(option) => t(`${option.name}`)}
      options={options}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      onChange={onChange}
      placeholder={placeholder}
      disableClearable={disableClearable}
    />
  );
};
